import { useState } from 'react';
import { Button, Dropdown, type MenuProps } from 'antd';
import { DownOutlined, PlusOutlined } from '@ant-design/icons';
import { SingleUploadFlow } from './SingleUploadFlow';
import { BulkUploadFlow } from './BulkUploadFlow';
import { PasteTextFlow } from './PasteTextFlow';

interface Props {
  onCreateBlank: () => void;
  onTopicCreated: () => void;
  investorOptions: string[];
}

/**
 * The "+ Add Topic ▾" dropdown that replaces the bare Add Topic button on
 * the Topics list page. Four entries: blank (existing /topics/new editor),
 * upload one flyer, upload many flyers, paste plain text.
 */
export function ImportEntryDropdown({ onCreateBlank, onTopicCreated, investorOptions }: Props) {
  const [openSingle, setOpenSingle] = useState(false);
  const [openBulk, setOpenBulk] = useState(false);
  const [openPaste, setOpenPaste] = useState(false);

  const items: MenuProps['items'] = [
    { key: 'blank', label: 'Blank topic', onClick: onCreateBlank },
    { type: 'divider' },
    { key: 'single', label: 'Upload flyer (image/PDF)', onClick: () => setOpenSingle(true) },
    { key: 'bulk', label: 'Upload many flyers (bulk)', onClick: () => setOpenBulk(true) },
    { key: 'paste', label: 'Paste text or JSON', onClick: () => setOpenPaste(true) },
  ];

  return (
    <>
      <Dropdown menu={{ items }} trigger={['click']}>
        <Button type="primary" icon={<PlusOutlined />}>
          Add Topic <DownOutlined />
        </Button>
      </Dropdown>

      <SingleUploadFlow
        open={openSingle}
        onClose={() => setOpenSingle(false)}
        onSaved={onTopicCreated}
        investorOptions={investorOptions}
      />
      <BulkUploadFlow
        open={openBulk}
        onClose={() => setOpenBulk(false)}
        onAnySaved={onTopicCreated}
        investorOptions={investorOptions}
      />
      <PasteTextFlow
        open={openPaste}
        onClose={() => setOpenPaste(false)}
        onSaved={onTopicCreated}
        investorOptions={investorOptions}
      />
    </>
  );
}
